const style = (theme) => {
  const output = {
    form: {
      display: 'flex',
      alignItems: 'center',
    },
    input: {
      background: theme.getRgba(theme.colors[1], 0.6),
      border: 'none',
      borderRadius: 0,
      width: '100%',
      fontFamily: theme.fonts[0],
    },
    inputDisabled: {
      pointerEvents: 'none',
    },
    hide: {
      opacity: 0,
    },
    spinner: {
      width: 20,
      height: 20,
      pointerEvents: 'none',
      transition: 'opacity 0.5s ease-in',
    },
    spinnerLoader: {
      stroke: theme.getRgba(theme.colors[3], 0.8),
      width: '100%',
      height: '100%',
      transition: 'all 1s ease-in',
      animation: '$rotate 2s linear infinite',
      '& .path': {
        strokeLinecap: 'round',
        animation: '$dash 1.5s ease-in-out infinite',
      },
    },
    '@keyframes rotate': {
      '100%': {
        transform: 'rotate(360deg)',
      },
    },
    '@keyframes dash': {
      '0%': {
        strokeDasharray: '1, 150',
        strokeDashoffset: '0',
      },
      '50%': {
        strokeDasharray: '90, 150',
        strokeDashoffset: '-35',
      },
      '100%': {
        strokeDasharray: '90, 150',
        strokeDashoffset: '-124',
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    form: {
      flex: 1,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
